import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiRequestService {

  apiURL = 'https://api-alwayson.recaudia.com/'

  constructor(private http: HttpClient) { }

  // Send stuffs to API
  sendPersonData(personData) {
    let _ = this;
    return _.http.post(_.apiURL + 'donor/create_landing', personData)
  }

  // Get stuffs of API
  getDesign(merchant){
  let _ = this;
  let conditionsRequest = {conditions: {merchant_id: merchant}};

  return _.http.post(_.apiURL + 'design/search_landing', conditionsRequest)
  }

}
